export const MODAL_ACTION_CLOSE = 'MODAL_ACTION_CLOSE';
export const MODAL_ACTION_CONFIRM = 'MODAL_ACTION_CONFIRM';
// export const API_ROOT = 'http://localhost:4700';
export const API_ROOT = 'https://vpuserver.herokuapp.com';
